var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebhookSkeletonSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 254,
    viewBox: "0 0 358 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 243.161,
    y: 154.562,
    width: 20.1981,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 267.75,
    y: 154.562,
    width: 20.1981,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 291.461,
    y: 154.562,
    width: 20.1981,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 317.807,
    y: 154.562,
    width: 12.2945,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 243.161,
    y: 166.045,
    width: 37.7617,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 243.161,
    y: 178.677,
    width: 12.2945,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 283.557,
    y: 166.045,
    width: 46.5435,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 258.09,
    y: 178.677,
    width: 25.4672,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 246.674,
    y: 190.161,
    width: 13.1727,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 280.923,
    y: 201.645,
    width: 28.9799,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 298.486,
    y: 190.161,
    width: 13.1727,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 263.359,
    y: 190.161,
    width: 31.6144,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 243.161,
    y: 201.645,
    width: 35.1271,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 287.07,
    y: 178.677,
    width: 45.6653,
    height: 4.59355,
    rx: 2.29677,
    fill: "#3A8FC8"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 85.832,
    y: 167.193,
    width: 27.5613,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 162.774,
    y: 178.677,
    width: 10.3355,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 146.697,
    y: 178.677,
    width: 10.3355,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 119.135,
    y: 190.161,
    width: 16.0774,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 170.813,
    y: 190.161,
    width: 44.7871,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 104.207,
    y: 201.645,
    width: 62.0129,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 138.658,
    y: 190.161,
    width: 27.5613,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 89.2773,
    y: 155.709,
    width: 58.5677,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 117.987,
    y: 167.193,
    width: 58.5677,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 150.142,
    y: 155.709,
    width: 36.7484,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 181.148,
    y: 167.193,
    width: 17.2258,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 189.187,
    y: 155.709,
    width: 17.2258,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 93.8711,
    y: 178.677,
    width: 48.2323,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 178.852,
    y: 178.677,
    width: 36.7484,
    height: 4.59355,
    rx: 2.29677,
    fill: "#0973BA"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 20.374,
    y: 56.9482,
    width: 60.9689,
    height: 4.59355,
    rx: 2.29677,
    fill: "#054570"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 20.374,
    y: 91.3999,
    width: 60.9689,
    height: 4.59355,
    rx: 2.29677,
    fill: "#054570"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 20.374,
    y: 68.4321,
    width: 43.1863,
    height: 4.59355,
    rx: 2.29677,
    fill: "#054570"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 20.374,
    y: 79.916,
    width: 83.8323,
    height: 4.59355,
    rx: 2.29677,
    fill: "#054570"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 20.374,
    y: 102.884,
    width: 83.8323,
    height: 4.59355,
    rx: 2.29677,
    fill: "#054570"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.826 90.2515L232.826 239.542",
    stroke: "#05386B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8002,
    cy: 37.9999,
    r: 2.87097,
    fill: "#042E4A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2841,
    cy: 37.9999,
    r: 2.87097,
    fill: "#042E4A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.7679,
    cy: 37.9999,
    r: 2.87097,
    fill: "#042E4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M347.664 77.5436C347.67 71.9798 346.551 66.4723 344.375 61.351C342.199 56.2297 339.011 51.6001 335.002 47.7397C330.993 43.8792 326.246 40.8674 321.044 38.8847C315.842 36.902 310.294 35.9892 304.731 36.2011C299.245 24.559 290.034 15.0755 278.553 9.24873C267.072 3.422 253.976 1.5842 241.334 4.02567C228.692 6.46714 217.224 13.0487 208.742 22.7306C200.259 32.4125 195.247 44.6428 194.496 57.4895C189.97 56.5422 185.291 56.6155 180.798 57.704C176.304 58.7926 172.111 60.869 168.522 63.782C164.933 66.695 162.039 70.3713 160.052 74.5431C158.064 78.715 157.033 83.2773 157.032 87.8979C157.032 119.458 190.186 118.961 190.186 118.961H310.367C310.367 118.961 347.664 114.107 347.664 77.5436Z",
    stroke: "#5C853A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M358 83.2853C358.005 77.7215 356.886 72.214 354.71 67.0927C352.535 61.9714 349.347 57.3418 345.338 53.4813C341.329 49.6209 336.581 46.6091 331.38 44.6264C326.178 42.6437 320.629 41.7309 315.066 41.9428C309.58 30.3007 300.369 20.8172 288.889 14.9904C277.408 9.16369 264.312 7.3259 251.67 9.76737C239.027 12.2088 227.559 18.7904 219.077 28.4723C210.595 38.1542 205.582 50.3845 204.831 63.2312C200.306 62.2839 195.626 62.3572 191.133 63.4457C186.64 64.5343 182.446 66.6107 178.857 69.5237C175.268 72.4367 172.375 76.113 170.387 80.2848C168.4 84.4566 167.368 89.019 167.368 93.6396C167.368 125.199 200.521 124.702 200.521 124.702H320.702C320.702 124.702 358 119.848 358 83.2853Z",
    fill: "#88C656"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.805 34.832C191.611 39.6263 190.857 44.5464 190.565 49.5336C184.295 48.2205 177.812 48.3221 171.586 49.831C165.36 51.3399 159.55 54.218 154.577 58.2559C149.605 62.2937 145.596 67.3895 142.842 73.1723C140.088 78.955 138.659 85.2791 138.658 91.6839C138.658 135.43 184.594 134.741 184.594 134.741H341.922L341.922 247.885C341.922 250.724 340.02 253.026 337.674 253.026H36.1062C33.7599 253.026 31.8579 250.724 31.8579 247.885L31.858 39.9722C31.858 37.1334 33.76 34.832 36.1063 34.832H192.805Z",
    fill: "#0973BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M253.743 47.9253C256.461 47.9253 258.665 45.4463 258.665 42.3884C258.665 39.3305 256.461 36.8516 253.743 36.8516C251.025 36.8516 248.821 39.3305 248.821 42.3884C248.821 45.4463 251.025 47.9253 253.743 47.9253Z",
    stroke: "#5C853A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M230.365 86.0679C233.083 86.0679 235.287 83.8647 235.287 81.1463C235.287 78.4282 233.083 76.2246 230.365 76.2246C227.647 76.2246 225.443 78.4282 225.443 81.1463C225.443 83.8647 227.647 86.0679 230.365 86.0679Z",
    stroke: "#5C853A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M275.89 86.0679C278.608 86.0679 280.812 83.8647 280.812 81.1463C280.812 78.4282 278.608 76.2246 275.89 76.2246C273.172 76.2246 270.969 78.4282 270.969 81.1463C270.969 83.8647 273.172 86.0679 275.89 86.0679Z",
    stroke: "#5C853A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M265.854 92.5418C271.9 98.6752 281.305 98.6752 287.351 92.5418C293.397 86.4084 293.397 76.8675 287.351 70.7341C282.313 65.623 274.587 64.9415 268.877 68.3489L256.204 46.6948",
    stroke: "#5C853A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M226.383 66.3818C220.318 68.1296 215.6 74.4215 215.6 81.4125C215.6 90.1512 222.34 97.1422 230.764 97.1422C239.189 97.1422 245.928 90.1512 245.928 81.4125H270.969",
    stroke: "#5C853A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M268.188 46.8814C269.183 41.8428 267.856 36.4684 264.206 32.7735C258.233 26.7272 248.941 26.7272 242.968 32.7735C236.331 39.8274 237.327 51.2482 245.954 56.6227L234.056 77.4554",
    stroke: "#5C853A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M341.923 117.56L341.923 234.402C341.923 237.241 339.619 239.542 336.777 239.542L7.14524 239.542C4.30365 239.542 2.00008 237.241 2.00008 234.402L2.00002 26.4886C2.00002 23.6497 4.30358 21.3484 7.14518 21.3484L155.31 21.3484",
    stroke: "#0973BA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebhookSkeletonSvg);
export default __webpack_public_path__ + "static/media/webhookSkeletonSVG.d77591ea2509eab5d5aff7392d7781f7.svg";
export { ForwardRef as ReactComponent };